import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { SharedModule } from '../../shared/shared.module';
import { WidgetAboutusComponent } from './widget-aboutus/widget-aboutus.component';
import { WidgetCategoriesComponent } from './widget-categories/widget-categories.component';
import { WidgetCommentsComponent } from './widget-comments/widget-comments.component';
import { WidgetNewsletterComponent } from './widget-newsletter/widget-newsletter.component';
import { WidgetPostsComponent } from './widget-posts/widget-posts.component';
import { WidgetProductsComponent } from './widget-products/widget-products.component';
import { WidgetSearchComponent } from './widget-search/widget-search.component';
import { WidgetTagsComponent } from './widget-tags/widget-tags.component';

@NgModule({
    declarations: [
        WidgetAboutusComponent,
        WidgetCategoriesComponent,
        WidgetCommentsComponent,
        WidgetNewsletterComponent,
        WidgetPostsComponent,
        WidgetProductsComponent,
        WidgetSearchComponent,
        WidgetTagsComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        NgxSliderModule,
        SharedModule
    ],
    exports: [
        WidgetAboutusComponent,
        WidgetCategoriesComponent,
        WidgetCommentsComponent,
        WidgetNewsletterComponent,
        WidgetPostsComponent,
        WidgetProductsComponent,
        WidgetSearchComponent,
        WidgetTagsComponent
    ]
})
export class WidgetsModule { }
